module.exports = __webpack_public_path__ + "img/actress.5f529688.webp";